import { StatCard } from '@wundo/ui';

export interface BroadcastCountsProps {
  total: number;
  sent: number;
  failed: number;
}

/** How many were asked for, how many went, how many did not. */
export function BroadcastCounts({ total, sent, failed }: BroadcastCountsProps) {
  return (
    <div className='grid grid-cols-3 gap-3'>
      <StatCard label='Total' value={total} />
      <StatCard label='Sent' value={sent} />
      <StatCard label='Failed' value={failed} />
    </div>
  );
}
